// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field, password-strength { width: 100% }
input:-webkit-autofill { -webkit-box-shadow: 0 0 0 1000px white inset !important; }
password-strength { margin-bottom: -10px; margin-top: -16px; display: block }

::ng-deep .mat-button:hover .mat-button-focus-overlay{ opacity: 0.04 !important;}

a { color: #00bcd4; cursor: pointer; }
.logo {
   display: block;
   height: 26px;
   margin: 30px auto 20px;
}

.title {
   font-size: 20px;
   font-weight: normal;
   margin: 0 0 10px;
   text-align: center;
}

.register-form {
   background-color: #fff;
   border: 1px solid rgba(0, 0, 0, .1);
   margin: 1em auto;
   padding: 0;
   width: 100%;
}

@media (min-width: 800px) {
   .two-column-edit {
      height: 550px;
      max-width: 800px;
   }

   .two-column-edit .column {
      float: left;
      width: 50%;
   }

   .two-column-edit .etax-column {
      border-left: 1px solid #e5e5e5;
   }
}

@media (min-width: 430px) {
   .two-column {
      height: 500px;
      max-width: 430px;
   }

   .two-column .column {
      float: left;
      width: 50%;
   }

   .two-column .etax-column {
      border-left: 1px solid #e5e5e5;
   }
}

.column {
   padding: 5px 50px;
   max-width: 420px;
}

.error {
   font-size: 13px;
   text-align: left;
   color: red;
}

.error_text {
   font-size: 12px;
   text-align: left;
   color: red;
   margin-top: -10px;
   margin-bottom: 10px;
}

.submit-button {
   display: block !important;
   margin: 0 auto 2em!important;
}

.div_resend {
   font-size: 13px;
   text-align: center;
   margin-bottom:10px;
}

.upload-button {
   border: 1px solid #00bcd4;
   color: #00b2c9;
   line-height: normal;
}

.upload-button i, .upload-button span {
   display: inline-block;
   vertical-align: middle;
}

.upload-button input[type=file] {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

.required {
   color: #F44336;
}

.hint {
   /*color: #FFA726;*/
   font-size: 11px;
}

.inactive {
   color: #ccc;
}

.file-list {
   font-size: 12px;
   list-style: none;
   margin: 8px 0;
   padding: 0;
}

.file-list li {
   line-height: 24px;
   padding-right: 24px;
   position: relative;
}

.file-list .file-name {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

.file-list .file-size {
   font-size: 11px;
}

.file-list mat-icon {
   color: #999;
   cursor: pointer;
   font-size: 20px;
   width: 20px;
   height: 20px;
   position: absolute;
   top: 2px;
   right: 0;
   opacity: 0;
   transition: opacity .1s, color .4s;
}

.file-list li:hover mat-icon {
   opacity: 1;
}

.file-list mat-icon:hover {
   color: #d32f2f;
}

#recaptcha {
   position: fixed;
   right: 0;
   bottom: 0;
   z-index: 999;
}

.login-header {
   text-align: center!important;
   font-size: 20px;
   margin-bottom: 40px;
}

.login-register {
   text-align: center!important;
   margin-top: 6px;
   margin-bottom: 1em;
}

.field-name {
   margin-top: 20px;
}

.pwd-hint {
   margin-bottom: 1em;
   padding: 10px 0px 20px;
}

.top-error {
   margin: 1em 0;
}

input {
   box-sizing: border-box;
   height: 32px;
   padding-right: 36px;
   width: 100%;
}

mat-icon {
   width: 32px;
   height: 32px;
   line-height: 32px;
   padding: 4px;
   text-align: center;
   position: absolute;
   right: 0;
}
.upgrade{
   font-weight: bold;
   margin: 30px 0 0 0!important;
   font-size: 15px;
   cursor: default!important;
   pointer-events: none;
   color: grey;
}
.text-indent{
   margin-left: 10px;
   font-size: 16px;
}
.text-main{
   font-size: 13px;
   margin-left: 55px;
}
.column-plan{
   margin-top: -15px;
   margin-left: -20px;
   max-width: 450px;
}
.plan{
   padding: 0 10px 10px 0;
}

.price{
   margin-left: 5px;
   color: #00bcd4;
}

.row-container{
   display: flex;
   flex: 1;
   justify-content: center;
   align-items: flex-start;
}

.border-right{
   border-right: 1px solid rgba(0, 0, 0, .1);
   max-height: 480px;
}
.register-link{
   font-size: 16px;
}
:host ::ng-deep .mat-radio-container{
   height: 15px;
   width: 15px;
}
:host ::ng-deep .mat-radio-outer-circle{
   height: 15px;
   width: 15px;
}
:host ::ng-deep .mat-radio-inner-circle{
   height: 15px;
   width: 15px;
}
:host ::ng-deep .mat-radio-button .mat-radio-ripple{
   height: 15px; /*double of your required circle radius*/
   width: 15px;  /*double of your required circle radius*/
   left: calc(50% - 15px); /*'10px'-same as your required circle radius*/
   top: calc(50% - 15px); /*'10px'-same as your required circle radius*/
}
.icon_pass{
   margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/sign-up/sign-up.component.css"],"names":[],"mappings":"AAAA,qCAAqC,YAAY;AACjD,yBAAyB,uDAAuD,EAAE;AAClF,oBAAoB,oBAAoB,EAAE,iBAAiB,EAAE,eAAe;;AAE5E,uDAAuD,wBAAwB,CAAC;;AAEhF,IAAI,cAAc,EAAE,eAAe,EAAE;AACrC;GACG,cAAc;GACd,YAAY;GACZ,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,mBAAmB;GACnB,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,sBAAsB;GACtB,mCAAmC;GACnC,gBAAgB;GAChB,UAAU;GACV,WAAW;AACd;;AAEA;GACG;MACG,aAAa;MACb,gBAAgB;GACnB;;GAEA;MACG,WAAW;MACX,UAAU;GACb;;GAEA;MACG,8BAA8B;GACjC;AACH;;AAEA;GACG;MACG,aAAa;MACb,gBAAgB;GACnB;;GAEA;MACG,WAAW;MACX,UAAU;GACb;;GAEA;MACG,8BAA8B;GACjC;AACH;;AAEA;GACG,iBAAiB;GACjB,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,gBAAgB;GAChB,UAAU;AACb;;AAEA;GACG,eAAe;GACf,gBAAgB;GAChB,UAAU;GACV,iBAAiB;GACjB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,4BAA4B;AAC/B;;AAEA;GACG,eAAe;GACf,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,mBAAmB;AACtB;;AAEA;GACG,qBAAqB;GACrB,sBAAsB;AACzB;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,kBAAkB;GAClB,eAAe;AAClB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,eAAe;GACf,gBAAgB;GAChB,aAAa;GACb,UAAU;AACb;;AAEA;GACG,iBAAiB;GACjB,mBAAmB;GACnB,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,eAAe;GACf,eAAe;GACf,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,QAAQ;GACR,QAAQ;GACR,UAAU;GACV,kCAAkC;AACrC;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,eAAe;GACf,QAAQ;GACR,SAAS;GACT,YAAY;AACf;;AAEA;GACG,4BAA4B;GAC5B,eAAe;GACf,mBAAmB;AACtB;;AAEA;GACG,4BAA4B;GAC5B,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,kBAAkB;GAClB,sBAAsB;AACzB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,sBAAsB;GACtB,YAAY;GACZ,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,YAAY;GACZ,kBAAkB;GAClB,kBAAkB;GAClB,QAAQ;AACX;AACA;GACG,iBAAiB;GACjB,4BAA4B;GAC5B,eAAe;GACf,yBAAyB;GACzB,oBAAoB;GACpB,WAAW;AACd;AACA;GACG,iBAAiB;GACjB,eAAe;AAClB;AACA;GACG,eAAe;GACf,iBAAiB;AACpB;AACA;GACG,iBAAiB;GACjB,kBAAkB;GAClB,gBAAgB;AACnB;AACA;GACG,sBAAsB;AACzB;;AAEA;GACG,gBAAgB;GAChB,cAAc;AACjB;;AAEA;GACG,aAAa;GACb,OAAO;GACP,uBAAuB;GACvB,uBAAuB;AAC1B;;AAEA;GACG,yCAAyC;GACzC,iBAAiB;AACpB;AACA;GACG,eAAe;AAClB;AACA;GACG,YAAY;GACZ,WAAW;AACd;AACA;GACG,YAAY;GACZ,WAAW;AACd;AACA;GACG,YAAY;GACZ,WAAW;AACd;AACA;GACG,YAAY,EAAE,wCAAwC;GACtD,WAAW,GAAG,wCAAwC;GACtD,sBAAsB,EAAE,6CAA6C;GACrE,qBAAqB,EAAE,6CAA6C;AACvE;AACA;GACG,mBAAmB;AACtB","sourcesContent":[".mat-form-field, password-strength { width: 100% }\ninput:-webkit-autofill { -webkit-box-shadow: 0 0 0 1000px white inset !important; }\npassword-strength { margin-bottom: -10px; margin-top: -16px; display: block }\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay{ opacity: 0.04 !important;}\n\na { color: #00bcd4; cursor: pointer; }\n.logo {\n   display: block;\n   height: 26px;\n   margin: 30px auto 20px;\n}\n\n.title {\n   font-size: 20px;\n   font-weight: normal;\n   margin: 0 0 10px;\n   text-align: center;\n}\n\n.register-form {\n   background-color: #fff;\n   border: 1px solid rgba(0, 0, 0, .1);\n   margin: 1em auto;\n   padding: 0;\n   width: 100%;\n}\n\n@media (min-width: 800px) {\n   .two-column-edit {\n      height: 550px;\n      max-width: 800px;\n   }\n\n   .two-column-edit .column {\n      float: left;\n      width: 50%;\n   }\n\n   .two-column-edit .etax-column {\n      border-left: 1px solid #e5e5e5;\n   }\n}\n\n@media (min-width: 430px) {\n   .two-column {\n      height: 500px;\n      max-width: 430px;\n   }\n\n   .two-column .column {\n      float: left;\n      width: 50%;\n   }\n\n   .two-column .etax-column {\n      border-left: 1px solid #e5e5e5;\n   }\n}\n\n.column {\n   padding: 5px 50px;\n   max-width: 420px;\n}\n\n.error {\n   font-size: 13px;\n   text-align: left;\n   color: red;\n}\n\n.error_text {\n   font-size: 12px;\n   text-align: left;\n   color: red;\n   margin-top: -10px;\n   margin-bottom: 10px;\n}\n\n.submit-button {\n   display: block !important;\n   margin: 0 auto 2em!important;\n}\n\n.div_resend {\n   font-size: 13px;\n   text-align: center;\n   margin-bottom:10px;\n}\n\n.upload-button {\n   border: 1px solid #00bcd4;\n   color: #00b2c9;\n   line-height: normal;\n}\n\n.upload-button i, .upload-button span {\n   display: inline-block;\n   vertical-align: middle;\n}\n\n.upload-button input[type=file] {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n.required {\n   color: #F44336;\n}\n\n.hint {\n   /*color: #FFA726;*/\n   font-size: 11px;\n}\n\n.inactive {\n   color: #ccc;\n}\n\n.file-list {\n   font-size: 12px;\n   list-style: none;\n   margin: 8px 0;\n   padding: 0;\n}\n\n.file-list li {\n   line-height: 24px;\n   padding-right: 24px;\n   position: relative;\n}\n\n.file-list .file-name {\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n.file-list .file-size {\n   font-size: 11px;\n}\n\n.file-list mat-icon {\n   color: #999;\n   cursor: pointer;\n   font-size: 20px;\n   width: 20px;\n   height: 20px;\n   position: absolute;\n   top: 2px;\n   right: 0;\n   opacity: 0;\n   transition: opacity .1s, color .4s;\n}\n\n.file-list li:hover mat-icon {\n   opacity: 1;\n}\n\n.file-list mat-icon:hover {\n   color: #d32f2f;\n}\n\n#recaptcha {\n   position: fixed;\n   right: 0;\n   bottom: 0;\n   z-index: 999;\n}\n\n.login-header {\n   text-align: center!important;\n   font-size: 20px;\n   margin-bottom: 40px;\n}\n\n.login-register {\n   text-align: center!important;\n   margin-top: 6px;\n   margin-bottom: 1em;\n}\n\n.field-name {\n   margin-top: 20px;\n}\n\n.pwd-hint {\n   margin-bottom: 1em;\n   padding: 10px 0px 20px;\n}\n\n.top-error {\n   margin: 1em 0;\n}\n\ninput {\n   box-sizing: border-box;\n   height: 32px;\n   padding-right: 36px;\n   width: 100%;\n}\n\nmat-icon {\n   width: 32px;\n   height: 32px;\n   line-height: 32px;\n   padding: 4px;\n   text-align: center;\n   position: absolute;\n   right: 0;\n}\n.upgrade{\n   font-weight: bold;\n   margin: 30px 0 0 0!important;\n   font-size: 15px;\n   cursor: default!important;\n   pointer-events: none;\n   color: grey;\n}\n.text-indent{\n   margin-left: 10px;\n   font-size: 16px;\n}\n.text-main{\n   font-size: 13px;\n   margin-left: 55px;\n}\n.column-plan{\n   margin-top: -15px;\n   margin-left: -20px;\n   max-width: 450px;\n}\n.plan{\n   padding: 0 10px 10px 0;\n}\n\n.price{\n   margin-left: 5px;\n   color: #00bcd4;\n}\n\n.row-container{\n   display: flex;\n   flex: 1;\n   justify-content: center;\n   align-items: flex-start;\n}\n\n.border-right{\n   border-right: 1px solid rgba(0, 0, 0, .1);\n   max-height: 480px;\n}\n.register-link{\n   font-size: 16px;\n}\n:host ::ng-deep .mat-radio-container{\n   height: 15px;\n   width: 15px;\n}\n:host ::ng-deep .mat-radio-outer-circle{\n   height: 15px;\n   width: 15px;\n}\n:host ::ng-deep .mat-radio-inner-circle{\n   height: 15px;\n   width: 15px;\n}\n:host ::ng-deep .mat-radio-button .mat-radio-ripple{\n   height: 15px; /*double of your required circle radius*/\n   width: 15px;  /*double of your required circle radius*/\n   left: calc(50% - 15px); /*'10px'-same as your required circle radius*/\n   top: calc(50% - 15px); /*'10px'-same as your required circle radius*/\n}\n.icon_pass{\n   margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
